export const SHOW_ALERT = "SHOW_ALERT"

export const showInfo = (text) => (dispatch) => {
  dispatch({
    type: SHOW_ALERT,
    payload: { message: text, type: "info" },
  });
};

export const showSuccess = (text) => (dispatch,) => {
  dispatch({
    type: SHOW_ALERT,
    payload: { message: text, type: "success" },
  });
};

export const showError = (text) => (dispatch) => {
  dispatch({
    type: SHOW_ALERT,
    payload: { message: text, type: "error" },
  });
};
